// extracted by mini-css-extract-plugin
export default {"container":"animated_div-module___container___e89722e3","root":"animated_div-module___root___d1258daa"};